import { Tooltip } from "@heroui/react";
import WarningIcon from '@mui/icons-material/Warning';
import { Column } from "./Layout";

export default function WarningTooltip({ content, maxWidth }: { content: React.ReactNode, maxWidth?: number }) {

    return (
        <Tooltip color="foreground" content={
            <Column padding={2} maxWidth={`${maxWidth ?? 240}px`} gap={2}>
                {content}
            </Column>
        }>
            <WarningIcon style={{ opacity: "0.75", color: "yellow" }} />
        </Tooltip>
    )
}